import ajax from "nanoajax";
import { hashHistory } from 'react-router'
import { normaliseIEStatusCode } from "./common/httpUtils"

const noop = () => {};

export function isHttpError(statusCode) {
    return statusCode >= 400 && statusCode <= 599;
}

export function isNetworkError(statusCode) {
    return statusCode === 0;
}

export default function (params, callback = noop, historyProvider = () => hashHistory) {
    ajax.ajax(params, (statusCode, text, request) => {
        if (statusCode === 401) {
            historyProvider().push("/sign-in");
        } else {
            callback(normaliseIEStatusCode(statusCode), text, request);
        }
    });
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/authenticationSafeAjax.js
 **/